module.exports = __webpack_public_path__ + "img/Leha.ed5a63fc.png";